interface IFontSource {
  uri?: string;
}

export interface IFontLoad {
  [key: string]: IFontSource;
}

export enum Fonts {
  RobotoLight = "RobotoLight",
  RobotoRegular = "RobotoRegular",
  RobotoBold = "RobotoBold",
  IconsRegular = "IconsRegular",
  IconsOutline = "IconsOutline",
  IconsRound = "IconsRound",
  IconsSharp = "IconsSharp",
}

export const SystemFonts: IFontLoad = {
  [Fonts.RobotoLight]: require("../../../../assets/fonts/Roboto-Light.ttf"),
  [Fonts.RobotoRegular]: require("../../../../assets/fonts/Roboto-Regular.ttf"),
  [Fonts.RobotoBold]: require("../../../../assets/fonts/Roboto-Bold.ttf"),
  [Fonts.IconsRegular]: require("../../../../assets/fonts/MaterialIcons-Regular.ttf"),
  [Fonts.IconsOutline]: require("../../../../assets/fonts/MaterialIconsOutlined-Regular.otf"),
  [Fonts.IconsRound]: require("../../../../assets/fonts/MaterialIconsRound-Regular.otf"),
  [Fonts.IconsSharp]: require("../../../../assets/fonts/MaterialIconsSharp-Regular.otf"),
};
